import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const TopicCard = styled.a`
  background: ${props => props.theme.color.lightGrey};
  color: ${props => props.theme.color.black} !important;
  display: flex;
  font-family: Verdana, Geneva, sans-serif;
  font-size: 15px;
  font-weight: ${props => props.theme.fontWeight.regular};
  height: 100px;
  margin: 10px;
  text-decoration: none;
  ${props =>
    props.isMobile
      ? `margin: 10px 0`
      : `width: 285px;
    `};
`;

const Img = styled.img`
  width: 150px;
`;

const P = styled.p`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
  padding: 10px;
  text-align: center;
  width: 60%;
`;

class Topic extends Component {
  static propTypes = {
    image: PropTypes.string,
    isMobile: PropTypes.bool,
    topic: PropTypes.object
  };

  render() {
    const { isMobile, topic, image } = this.props;
    const { buttonText, stepId, title } = topic;
    const slug = title
      .replace(/ /g, '-')
      .replace(/:/g, '')
      .toLowerCase();
    return (
      <TopicCard
        rel="external"
        isMobile={isMobile}
        href={`/support/help/${slug}/${stepId}`}
      >
        <P>{buttonText}</P>
        {image && <Img src={this.props.image} alt={buttonText} />}
      </TopicCard>
    );
  }
}

export default Topic;



// WEBPACK FOOTER //
// ./src/components/Topic/index.js